// extracted by mini-css-extract-plugin
export default {"confirm-iframe":"confirm-login-control_confirm-iframe__o6swa"};